import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTroveComponent } from './simple-icons-trove.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTroveComponent ],
    exports:      [ SimpleIconsTroveComponent ],
    bootstrap:    []
})
export class SimpleIconsTroveModule {}
